export default __webpack_public_path__ + "locales/hy-AM/PortalUnavailable.json?hash=579888f5e82170786e2722061c99a402";